export const exportRecommendationsReportsMutation = `mutation exportRecommendationsReports($input: ExportRecommendationsReportsInput) {
    exportRecommendationsReports(input: $input) {
        status
        details
        error {
            message
            date
        }
    }
}`;